// interfaces.
import { RawRuleItem } from "@store/apiSlices/incentiveRules/interfaces/rawRules.interfaces";

// components.
import { RulePanelRow } from "./RulePanelRow";

interface GanadorPanelProps {
  rules: RawRuleItem[];
  canLock: boolean;
  onLock: () => void;
  onEdit: (rule: RawRuleItem) => void;
  onToggle: (rule: RawRuleItem) => void;
}

export const GanadorPanel = ({ rules, canLock, onLock, onEdit, onToggle }: GanadorPanelProps) => {
  const activeCount = rules.filter((r) => r.is_active === "active").length;
  const sorted = [...rules].sort((a, b) => a.rule.priority - b.rule.priority);

  return (
    <div className="dashboard-panel dashboard-panel--rules">
      <div className="panel-header">
        <div className="panel-title-group">
          <span className="boxing-label label--ganador">🏆 Winner</span>
          <p className="panel-title">Reglas de producción</p>
          <span className="panel-count count--rules">
            {activeCount} activa{activeCount !== 1 ? "s" : ""}
          </span>
        </div>
        <button
          className="icon-btn icon-btn--lock"
          onClick={onLock}
          disabled={!canLock}
          title={canLock ? "Mover toda la ruta a Confianza (hold out)" : "No hay reglas activas"}
        >
          🔒 Hold out
        </button>
      </div>

      <div className="panel-body">
        {sorted.length === 0 ? (
          <p className="panel-empty">No hay reglas de producción para esta sub-ruta.</p>
        ) : (
          sorted.map((rule) => (
            <RulePanelRow
              key={rule.rule_id}
              rule={rule}
              variant="winner"
              onEdit={onEdit}
              onToggle={onToggle}
            />
          ))
        )}
      </div>
    </div>
  );
};
